import React, {useEffect, useState} from 'react'
import SweetAlert from 'react-bootstrap-sweetalert'
import Nav from './Navbar';
import firma from "./iconos/firma.png";
import firmaMovil from './imagenes/firmaMovil.png';
import { Link } from 'react-router-dom';
import playstore from "./iconos/Playstore.png";
import appstore from "./iconos/appstore.png";
import llamada from "./iconos/llamada.png";
import mail from "./iconos/mail.png";
import gpsRojo from "./iconos/gps_rojo.png";
import trianguloAzul from "./imagenes/triangulo_azul.png";
import trianguloRojo from "./imagenes/triangulo_rojo.png";
import lifter from "./imagenes/Lifter.png";
import FondoMovil from './imagenes/fondoMovil.jpg';
import Telefono from './imagenes/telefono.png';
import Mensaje from './imagenes/mensaje.png';
import UbicacionMovil from './imagenes/ubicacionMovil.png';
import Footer from './Footer';
//import Auth from '../middleware/Auth';

function Servicios(props) {

    const [nombre,setNombre] = useState("")
    const [correo,setCorreo] = useState("")
    const [telefono,setTelefono] = useState("")
    const [asunto,setAsunto] = useState("")
    const [mensaje, setMensaje] = useState("");
    const [rubro,setRubro] = useState("")
    const [nombreEmpresa, setNombreEmpresa] = useState("");
    const [mostrarAdvertencia, setMostrarAdvertencia] = useState(true)
    const [Alert, setAlert] = useState(null);

    
    const enviarMensaje =()=>{
        if(nombre!="" && correo!="" && telefono!="" && asunto!="" && mensaje!="" && rubro!="" && nombreEmpresa!=""){
            var URL = "https://api.subcargo.com/api/v1/email"
            var remitentes = ["lespinoza@subcargo.com", "validacion@subcargo.com","nmadrid@subcargo.com","aportilla@subcargo.com", "servidores@subcargo.com"]
            var data = { 
                "Nombre": nombre,
                "Correo": correo,
                "Telefono": telefono,
                "Asunto": asunto,
                "Mensaje": mensaje,
                "Rubro": rubro,
                "NombreEmpresa": nombreEmpresa,
                "Remitentes": remitentes
            }

            fetch(URL, {
                method: "POST",
                headers:{
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(data)
            }).then((res)=>{
                console.log("res mensaje enviado", res)
                setAlert(
                    <SweetAlert confirm title="Mensaje enviado" onConfirm={()=>setAlert(null)}>
                      Mensaje enviado exitosamente, gracias por ponerse en contacto con nosotros.
                    </SweetAlert>
                  )
                return res.json()
            })
            setMostrarAdvertencia(true)
        }else{
            setMostrarAdvertencia(false)
        }


    }
    //useEffect
    return (
        <div className="App">
            {Alert}
{/*<----------------------------------------------------------------------- ESCRITORIO ----------------------------------------------------------------------------------------->*/}
            
            <div className='hidden lg:flex h-auto bg-camion relative'>
                <div className='bg-gradiente-subcargo absolute w-full h-full'/>
                <Nav active="/contacto"/>
                {/* <img className='' src={camionFondo}></img> */}
                <div className='bg-camion h-[557px] w-full flex flex-col text-center justify-center align-middle'>  
                    <div className='text-subtitulo align-middle z-10'>Contáctanos</div>
                </div>
            </div>

            <div className='hidden h-[200px] lg:flex flex-row bg-white justify-around'>
                <div className='flex flex-col mt-10 items-center'>
                    <div>
                        <img src={llamada}></img>
                    </div>
                    <text className='text-rojo fonr-face-rwBlack text-2xl my-5'>Escríbenos por Whatsapp</text>
                    <text className='text-black-900 font-face-rwRegular text-xl'>+56 9 9480 3359</text>
                </div>
                <div className='flex flex-col mt-10 items-center'>
                    <div>
                        <img src={mail}></img>
                    </div>
                    <text className='text-rojo fonr-face-rwBlack text-2xl my-5'>Escríbenos</text>
                    <text className='text-black-900 font-face-rwRegular text-xl'>contacto@subcargo.com</text>
                </div>
                <div className='flex flex-col mt-10 items-center'>
                    <div>
                        <img src={gpsRojo}></img>
                    </div>
                    <text className='text-rojo fonr-face-rwBlack text-2xl my-5'>Visítanos</text>
                    <text className='text-black-900 font-face-rwRegular text-xl'>Av. Miraflores 9443, Pudahuel, Santiago, Chile</text>
                </div>
            </div>

            <div className='hidden lg:block h-auto bg-calles2 mt-[150px] relative'>
                <div className='h-[600px] relative bg-gradiente-subcargo-horizontal w-full flex flex-row text-center justify-center align-middle'>  
                    <div className='flex flex-col w-1/3 mt-10'>
                        <div className='w-[267px]'>
                            <img className='ml-32' src={firma}/>
                            <text className='text-white font-face-rwBlack text-[64px]'>Hablemos</text>
                        </div>
                    </div>
                    
                    <form action="" className='relative bg-transparent mr-[600px] mt-11'>
                        <div className='bg-transparent mb-5'>
                            <input value={nombre}  onChange={e=>setNombre(e.target.value)} type="text" className='text-[20px] font-face-rwBold bg-transparent border-2 border-white w-[290%] py-2 px-3 text-white leading-tight focus:outline-none focus:shadow-outline placeholder:text-white'
                            placeholder='Nombre:'
                            />
                        </div>
                        <div className='bg-transparent mb-5'>
                            <input value={correo}  onChange={e=>setCorreo(e.target.value)} type="text" className='text-[20px] font-face-rwBold bg-transparent border-2 border-white w-[290%] py-2 px-3 text-white leading-tight focus:outline-none focus:shadow-outline placeholder:text-white'
                            placeholder='Correo:'
                            />
                        </div>
                        <div className='bg-transparent mb-5'>
                            <input value={telefono}  onChange={e=>setTelefono(e.target.value)} type="text" className='text-[20px] font-face-rwBold bg-transparent border-2 border-white w-[290%] py-2 px-3 text-white leading-tight focus:outline-none focus:shadow-outline placeholder:text-white'
                            placeholder='Teléfono:'
                            />
                        </div>
                        <div className='bg-transparent mb-5'>
                            <input value={asunto}  onChange={e=>setAsunto(e.target.value)} type="text" className='text-[20px] font-face-rwBold bg-transparent border-2 border-white w-[290%] py-2 px-3 text-white leading-tight focus:outline-none focus:shadow-outline placeholder:text-white'
                            placeholder='Asunto:'
                            />
                        </div>
                        <div className='bg-transparent mb-5'>
                            <input value={mensaje}  onChange={e=>setMensaje(e.target.value)} type="text" className='text-[20px] font-face-rwBold bg-transparent border-2 border-white w-[290%] py-2 px-3 text-white leading-tight focus:outline-none focus:shadow-outline placeholder:text-white'
                            placeholder='Mensaje:'
                            />
                        </div>
                        <div className='bg-transparent mb-5'>
                            <input value={nombreEmpresa}  onChange={e=>setNombreEmpresa(e.target.value)} type="text" className='text-[20px] font-face-rwBold bg-transparent border-2 border-white w-[290%] py-2 px-3 text-white leading-tight focus:outline-none focus:shadow-outline placeholder:text-white'
                            placeholder='Nombre de la Empresa'
                            />
                        </div>
                        <div className='bg-transparent mb-5'>
                            <input value={rubro}  onChange={e=>setRubro(e.target.value)} type="text" className='text-[20px] font-face-rwBold bg-transparent border-2 border-white w-[290%] py-2 px-3 text-white leading-tight focus:outline-none focus:shadow-outline placeholder:text-white'
                            placeholder='Rubro'
                            />
                        </div>
                    </form>
                    <div className='absolute flex justify-left mt-[500px]'>
                        <button onClick={()=>{enviarMensaje()}} className='font-face-rwBlack text-rojo text-2xl bg-white w-[220px] h-[44px]'>Enviar</button>
                        <p hidden={mostrarAdvertencia} className='font-face-rwRegular mt-2 ml-16 text-azul text-xl h-[44px]'>*Por favor rellene todos los campos</p>
                    </div>
                    <img className='absolute top-0 right-0 -z-9' src={trianguloAzul}></img>
                    <img className='absolute bottom-0 left-0 -z-9' src={trianguloRojo}></img>
                </div>
                <div className='h-[600px] w-full flex flex-row text-center justify-around align-middle'>  
                    <div className='mt-20'>
                        <img src={lifter}/>
                    </div>
                    <div className='flex flex-col mt-10 w-[662px]'>
                        <text className='text-azul font-face-rwBlack text-[52px] h-[393px] text-left'>¿Cómo ser parte de la red de transporte de carga más grande de Chile?</text>
                        <Link to={{ pathname: "https://sistema.subcargo.com/#/login"}} target="_blank">
                            <button className='ml-8 font-face-rwBlack text-white text-2xl bg-azul w-[372px] h-[69px] rounded-[5px]'>
                                REGÍSTRATE
                            </button>
                        </Link>
                            
                    </div>
                </div>
            </div>

{/*<------------------------------------------------------------------------- MOVIL ----------------------------------------------------------------------------------------------------->*/}
            <div className='lg:hidden flex seccion-principal relative'>
                <div className='bg-gradiente-subcargo absolute w-full h-full'/>
                <Nav active="/contacto"/>
                <img src={FondoMovil} className="h screen w-screen z-[-2]"/>
                <div className='absolute h-full w-full flex flex-col'>  
                    <div className='h-1/4'></div>
                    <div className='font-face-rwBlack text-[28px] text-white text-center'>Contáctanos</div>
                    {/* <div className='font-face-rwBold text-white text-[14px] text-center'>Lorem ipsum dolor sit amet consectetur adipiscing astie massa convallis</div> */}
                    <div className="flex flex-row ml-8 mt-80">
                        <img src={Telefono} className='scale-[.35]'/>
                        <div className='relative font-face-rwBlack text-[11px] text-white mt-8 -ml-3'>Escríbenos por Whatsapp</div>
                        <div className='absolute font-face-rwMedium text-[9px] w-40 text-white text-left mt-12 ml-20'>+56 9 9480 3359</div>
                        
                    </div>
                    <div className="flex flex-row ml-8">
                        <img src={Mensaje} className='scale-[.35]'/>
                        <div className='relative font-face-rwBlack text-[11px] text-white mt-8 -ml-3'>Escríbenos</div>
                        <div className='absolute font-face-rwMedium text-[9px] w-32 text-white text-left mt-12 ml-20'>contacto@subcargo.com</div>
                    </div>
                    <div className="flex flex-row ml-8">
                        <img src={UbicacionMovil} className='scale-[.35]'/>
                        <div className='relative font-face-rwBlack text-[11px] text-white mt-8 -ml-3'>Visítanos</div>
                        <div className='absolute font-face-rwMedium text-[9px] w-32 text-white text-left mt-12 ml-20'>Av. Miraflores 9443, Pudahuel, Santiago, Chile.</div>
                    </div>
                </div>
            </div>

            <div className='lg:hidden h-full flex seccion-secundaria bg-white relative'>
                    <div className='flex flex-col mt-10'>
                        <div className='block'>
                            <img className='absolute scale-50 right-0' src={firmaMovil} />
                            <text className='absolute text-[#142A50] font-face-rwBlack text-[28px] mt-20 right-12'>Hablemos</text>
                        </div>
                    </div>

                    <form action="" className='relative bg-transparent left-10 mt-48 z-[20]'>
                        <div className='bg-transparent mb-5'>
                            <input value={nombre}  onChange={e=>setNombre(e.target.value)} type="text" className='text-[14px] font-face-rwBold bg-transparent border-[1px] border-[#142A50] w-[80vw] py-2 px-3 text-[#142A50] leading-tight focus:outline-none focus:shadow-outline placeholder:text-[#142A50]'
                            placeholder='Nombre:'
                            />
                        </div>
                        <div className='bg-transparent mb-5'>
                            <input value={correo}  onChange={e=>setCorreo(e.target.value)} type="text" className='text-[14px] font-face-rwBold bg-transparent border-[1px] border-[#142A50] w-[80vw] py-2 px-3 text-white leading-tight focus:outline-none focus:shadow-outline placeholder:text-[#142A50]'
                            placeholder='Correo:'
                            />
                        </div>
                        <div className='bg-transparent mb-5'>
                            <input  value={telefono}  onChange={e=>setTelefono(e.target.value)} type="text" className='text-[14px] font-face-rwBold bg-transparent border-[1px] border-[#142A50] w-[80vw] py-2 px-3 text-white leading-tight focus:outline-none focus:shadow-outline placeholder:text-[#142A50]'
                            placeholder='Teléfono:'
                            />
                        </div>
                        <div className='bg-transparent mb-5'>
                            <input  value={asunto}  onChange={e=>setAsunto(e.target.value)} type="text" className='text-[14px] font-face-rwBold bg-transparent border-[1px] border-[#142A50] w-[80vw] py-2 px-3 text-white leading-tight focus:outline-none focus:shadow-outline placeholder:text-[#142A50]'
                            placeholder='Asunto:'
                            />
                        </div>
                        <div className='bg-transparent mb-5'>
                            <input  value={mensaje}  onChange={e=>setMensaje(e.target.value)} type="text" className='text-[14px] font-face-rwBold bg-transparent border-[1px] border-[#142A50] w-[80vw] py-2 px-3 text-white leading-tight focus:outline-none focus:shadow-outline placeholder:text-[#142A50]'
                            placeholder='Mensaje:'
                            />
                        </div>
                        <div className='bg-transparent mb-5'>
                            <input  value={nombreEmpresa}  onChange={e=>setNombreEmpresa(e.target.value)} type="text" className='text-[14px] font-face-rwBold bg-transparent border-[1px] border-[#142A50] w-[80vw] py-2 px-3 text-white leading-tight focus:outline-none focus:shadow-outline placeholder:text-[#142A50]'
                            placeholder='Nombre de la Empresa'
                            />
                        </div>
                        <div className='bg-transparent mb-5'>
                            <input  value={rubro}  onChange={e=>setRubro(e.target.value)} type="text" className='text-[14px] font-face-rwBold bg-transparent border-[1px] border-[#142A50] w-[80vw] py-2 px-3 text-white leading-tight focus:outline-none focus:shadow-outline placeholder:text-[#142A50]'
                            placeholder='Rubro'
                            />
                        </div>
                    </form>

                    <div className='absolute flex justify-left left-10 mt-[600px] z-[20]'>
                        <button onClick={()=>{enviarMensaje()}} className='font-face-rwBlack text-white text-[18px] bg-[#142A50] w-24 h-9'>Enviar</button>
                        <p hidden={mostrarAdvertencia} className='font-face-rwRegular mt-2 ml-5 text-azul text-[14px] h-9'>*Por favor rellene todos los campos</p>
                    </div>
                <div className='lg:hidden flex absolute h-screen flex-col justify-center mt-[530px]'>  
                    <div className='flex flex-row relative right-5'>
                        <img src={lifter} className='scale-75'/> 
                    </div>
                    <text className="relative text-azul font-face-rwBlack text-[18px] w-[80vw] text-center left-8 flex flex-row">¿Cómo ser parte de la red de transporte de carga más grande de Chile?</text>
                    <div className='relative flex flex-row scale-75 justify-center z-[20]'>
                    <Link to={{ pathname: "https://sistema.subcargo.com/#/login"}} target="_blank">
                        <button className='font-face-rwBlack text-white button-gradiente'>Regístrate</button>
                    </Link> 
                    </div>
                    <div className='relative flex flex-row scale-75 justify-center'>
                        <text className='text-azul font-face-rwRegular text-2xl mr-5 mt-5'>Disponible en </text>
                        <img src={playstore} className='cursor-pointer'/>
                        <img src={appstore} className='cursor-pointer'/>
                    </div>
                </div>
            </div>
            
            <Footer/>
        </div>
    )
}

export default Servicios